"use client";
import { ErrorState } from "@/components/ui";
export default function ErrorPage({
  reset,
}: {
  error: Error;
  reset: () => void;
}) {
  return (
    <ErrorState
      error="Произошла ошибка при открытии страницы. Попробуйте загрузить её снова."
      retry={reset}
    />
  );
}
